import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { withRouter } from 'react-router';
import moment from 'moment';
import DeleteModal from '../DeleteModal/DeleteModal';
import './styles/userFamilyMemebers.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedUserFamilyMembers(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  // Delete user.
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState();

  // Update User.
  const [userToUpdate, setUserToUpdate] = useState();

  // New User.
  const [validated, setValidated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [creatingUser, setCreatingUser] = useState(false);
  const [birthDate, setBirthDate] = useState();
  const [document, setDocument] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userRelationship, setUserRelationship] = useState('');

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (userToDelete) setShowDeleteModal(true);
  }, [userToDelete]);

  useEffect(() => {
    if (userToUpdate) {
      setFirstName(userToUpdate.firstName);
      setLastName(userToUpdate.lastName);
      setBirthDate(moment.utc(userToUpdate.birthDate).format('YYYY-MM-DD'));
      setDocument(userToUpdate.document);
      setUserRelationship(userToUpdate.userRelationship);
      setShowModal(true);
    }
  }, [userToUpdate]);

  const getData = async () => {
    setLoading(true);

    const usersProm = await fetch(`${apiUrl}/users/family/get`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const usersResp = await usersProm.json();
    if (usersResp.success) setUsers(usersResp.users);

    setLoading(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setCreatingUser(false);
    setValidated(false);
    setBirthDate();
    setDocument('');
    setFirstName('');
    setLastName('');
    setUserRelationship('');
    setUserToUpdate();
  };

  const closeDeleteModal = () => {
    setUserToDelete();
    setShowDeleteModal(false);
  };

  const deleteUser = async () => {

    if (userToDelete) {
      const deleteProm = await fetch(`${apiUrl}/users/family/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: userToDelete._id
        })
      });

      const deleteResp = await deleteProm.json();

      if (!deleteResp.success) {
        alert('Ocurrió un error, inténtalo nuevamente.');
      } else {
        alert('Usuario eliminado.');
        getData();
      }

      closeDeleteModal();
    }
  };

  const createUser = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {

      setCreatingUser(true);

      if (userToUpdate) {

        const updateProm = await fetch(`${apiUrl}/users/family/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId,
            token,
            businessName,
            id: userToUpdate._id,
            birthDate,
            document,
            firstName,
            lastName,
            userRelationship
          })
        });

        const updateResp = await updateProm.json();

        if (!updateResp.success) {
          alert(updateResp.message || 'Ocurrió un error, inténtalo nuevamente.');
        } else {
          alert('Usuario actualizado.');
          getData();
        }

      } else {

        const createProm = await fetch(`${apiUrl}/users/family/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            userId,
            token,
            businessName,
            birthDate,
            document,
            firstName,
            lastName,
            userRelationship
          })
        });

        const createResp = await createProm.json();

        if (!createResp.success) {
          alert(createResp.message || 'Ocurrió un error, inténtalo nuevamente.');
        } else {
          alert('Usuario creado.');
          getData();
        }

      }

      closeModal();
    }

  };

  if (loading) {
    return (
      <div className="user-family-members-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="user-family-members-component">
      <Container>
        <Row>
          <Col>
            <h3>Miembros familiares</h3>
            <Row>
              <Col xs={12}>
                <Alert variant="info">
                  Puedes agregar miembros de tu familia para que utilicen la plataforma.
                  Recuerda que puedes agregar máximo 3 miembros familiares.
                </Alert>
              </Col>
              <Col sm={4}></Col>
              <Col sm={4}></Col>
              <Col sm={4}>
                <Button
                  className="app-button"
                  disabled={users.length >= 3}
                  style={{ width: '100%', maxWidth: '250px', float: 'right', marginBottom: '15px' }}
                  onClick={() => setShowModal(true)}
                >
                  Agregar miembro familiar
                </Button>
              </Col>
            </Row>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombres</th>
                  <th>Apellidos</th>
                  <th>Identificación</th>
                  <th>Fecha de nacimiento</th>
                  <th style={{ textAlign: 'center' }}>Opciones</th>
                </tr>
              </thead>
              <tbody>
                {
                  users.map((user, index) =>
                    <tr key={user._id}>
                      <td>{index + 1}</td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.document}</td>
                      <td>{moment.utc(user.birthDate).format('YYYY-MM-DD')}</td>
                      <td>
                        {
                          !user.accountCreated ?
                          <div style={{ display: 'block', margin: '0 auto', width: 'fit-content' }}>
                            <i className="fas fa-edit" onClick={() => setUserToUpdate(user)} />
                            <i className="fas fa-trash-alt delete-icon" onClick={() => setUserToDelete(user)} />
                          </div> :
                          <div></div>
                        }
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

      <DeleteModal
        show={showDeleteModal}
        text={userToDelete ? `el usuario ${userToDelete.firstName}` : ''}
        onClose={closeDeleteModal}
        onDelete={deleteUser}
      />

      <Modal show={showModal} onHide={closeModal} size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Form onSubmit={createUser} noValidate validated={validated}>
          <Modal.Body>
            <Form.Row>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Nombres</Form.Label>
                <Form.Control
                  type="text"
                  value={firstName}
                  placeholder="Nombres"
                  onChange={event => setFirstName(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Apellidos</Form.Label>
                <Form.Control
                  type="text"
                  value={lastName}
                  placeholder="Apellidos"
                  onChange={event => setLastName(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Fecha de nacimiento</Form.Label>
                <Form.Control
                  type="date"
                  value={birthDate}
                  onChange={event => setBirthDate(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Documento de identificación</Form.Label>
                <Form.Control
                  type="text"
                  value={document}
                  placeholder="Documento"
                  onChange={event => setDocument(event.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} sm={6}>
                <Form.Label>Parentesco</Form.Label>
                <Form.Control
                  type="text"
                  value={userRelationship}
                  placeholder="Parentesco"
                  onChange={event => setUserRelationship(event.target.value)}
                  required
                />
              </Form.Group>

            </Form.Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="info" type="submit" disabled={creatingUser}>
              {
                creatingUser ? <Spinner variant="warning" size="sm" animation="border" /> :
                (userToUpdate ? 'Editar' : 'Crear')
              }
            </Button>
            <Button variant="secondary" onClick={closeModal}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

const UserFamilyMembers = connect(select)(ConnectedUserFamilyMembers);

export default withRouter(UserFamilyMembers);
